
<template>
  <div>
    <!--https://github.com/ankurk91/vue-loading-overlay/issues/26-->
    <b-modal
      :title="$t('modal.product_sheets.title_request_campaign')"
      :id="modalId"
      :ok-title="$t('modal.general.ok_button')"
      :cancel-title="$t('modal.general.cancel_button')"
      :no-enforce-focus="true"
      @show="resetForm"
      @ok="verifyForm">
      <b-form @submit.prevent="verifyForm" v-if="userMarket">

        <!--PRODUCT CAMPAIGN-->
        <b-form-group
          id="product-campaign-group"
          :label="$t('form.products.campaign')"
          :description="$t('form.products.campaign_request_help_text')"
          :invalid-feedback="invalidProductCampaign"
          :state="stateProductCampaign"
          label-for="product-campaign"
        >
          <multiselect
            id="product-campaign"
            v-model="productCampaign"
            :select-label="$t('multiselect.select_label')"
            :deselect-label="$t('multiselect.cannot_deselect')"
            :selected-label="$t('multiselect.selected_label')"
            :class="{ 'invalid-multiselect': $v.productCampaign.$error }"
            :placeholder="$t('multiselect.placeholder', { field: $t('form.products.campaign').toLowerCase() })"
            :options="userMarket.productCampaigns"
            track-by="id"
            :allow-empty="false"
            label="displayName">
          </multiselect>
        </b-form-group>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
  import { required } from 'vuelidate/lib/validators'
  import { mapState } from 'vuex'


  export default {
    name: 'RequestCampaignModal',

    data () {
      return {
        productCampaign: null,
        loader: false,
      }
    },

    props: {
      modalId: {
        type: String,
        required: true
      },
    },

    validations: {
      productCampaign: {
        required
      },
    },

    computed: {
      ...mapState(['userMarket', 'customerData']),


      // VALIDATIONS
      stateProductCampaign () {
        return (!this.$v.productCampaign.$error)
      },
      invalidProductCampaign () {
        if (this.$v.productCampaign.$error) {
          if (!this.$v.productCampaign.required)
            return this.$t('validation.required', { field: this.$t('form.products.campaign') })
        }
        return null
      },
    },

    methods: {

      resetForm () {
        this.$v.$reset()
      },
      verifyForm (bvModalEvt) {
        bvModalEvt.preventDefault()
        this.$v.$touch()
        if (this.$v.$invalid)
          return
        this.requestCampaign()
      },
      requestCampaign () {
        if (this.loading)
          return
        this.loading = true
        this.loader = this.$loading.show(this.$_loaderOptions)
        this.$store.dispatch(this.$_actionTypes.REQUEST_PRODUCT_CAMPAIGN, {
          id: this.productCampaign.id,
          userNumber: this.customerData.userNumber,
        })
          .then(() => {
            this.$notify({
              group: 'app',
              type: 'success',
              title: this.$t('notifications.title.success'),
              text: this.$t('notifications.text.product_sheets.success_campaign_requested')
            })
            this.$nextTick(() => {
              this.$bvModal.hide(this.modalId)
            })
          })
          .catch((error) => {
            this.$_notifyError(error, this)
          })
          .finally(() => {
            this.loader.hide()
            this.loading = false
          })
      }
    }
  }
</script>

<style>

</style>
